import { apiFetch } from "./client";
import {
  canonicalStockyPublicBigIntId,
  type StockyPublicBigIntId,
} from "./stocky_public_ids";

/** ある週に必要になる仕入現金の集計（`week_start` は ISO 週頭=月曜）。 */
export interface CashflowBucket {
  week_start: string;
  amount: string;
  supplier_count: number;
  line_count: number;
}

export interface CashflowCalendar {
  horizon_weeks: number;
  total_amount: string;
  /** horizon より先に落ちる（リードタイムが長い）投影額。0円でも「先が無い」と誤解させないよう常に返る。 */
  beyond_horizon_amount: string;
  buckets: CashflowBucket[];
}

export const CASHFLOW_DEFAULT_HORIZON_WEEKS = 8;
/** ユーザーが選べる見通し週数。backend `MAX_HORIZON_WEEKS`(26) の範囲内。 */
export const CASHFLOW_HORIZON_WEEK_OPTIONS = [4, 8, 13, 26] as const;

/**
 * 仕入れ資金繰りカレンダーを取得する（Starter+ 看板機能＝発注点ロジックの上に立つ）。
 *
 * `locationId` は拠点別ドラフト用（Business 限定）。null=未選択（バックエンドが主拠点へ解決）。
 * バックエンドは非Starter+に 403 を返すため、呼び出し側はプランで事前ゲートしてから呼ぶ。
 */
export function getCashflowCalendar(
  weeks: number = CASHFLOW_DEFAULT_HORIZON_WEEKS,
  locationId: StockyPublicBigIntId | null = null,
): Promise<CashflowCalendar> {
  const query: Record<string, string | number | undefined> = { weeks };
  if (locationId !== null) {
    query.location_id = canonicalStockyPublicBigIntId(locationId);
  }
  return apiFetch<CashflowCalendar>("/api/purchase-orders/cashflow", { query });
}
